import { STORAGE_KEYS } from '@ukpostbox/frontend-framework/lib/FrameworkStorageKeys';
import { AuthorisedUserStoreActionsType } from '../../Types/AuthorisedUserReducerTypes';
import { AuthorisedUserStoreStateType } from '../../Types/AuthorisedUserStoreTypes';

export default function AuthorisedUserReducer(
	state: AuthorisedUserStoreStateType,
	action: AuthorisedUserStoreActionsType,
): AuthorisedUserStoreStateType {
	switch (action.type) {
		case 'setCurrentUser':
			return {
				...state,
				currentUser: action.payload,
				canByPassLocks: action.payload.permissions.includes('Admin_AllowLockBypass'),
			};
		case 'setUserPreferences':
			localStorage.setItem(STORAGE_KEYS.FRAMEWORK_PREFERENCES, JSON.stringify(action.payload));

			return { ...state, userPreferences: action.payload };
		case 'updateUserPreferences':
			const updatedPreferences = state.userPreferences
				? { ...state.userPreferences, ...action.payload }
				: action.payload;

			localStorage.setItem(STORAGE_KEYS.FRAMEWORK_PREFERENCES, JSON.stringify(updatedPreferences));

			return { ...state, userPreferences: updatedPreferences };
		case 'resetUserPreferences':
			localStorage.removeItem(STORAGE_KEYS.FRAMEWORK_PREFERENCES);

			return { ...state, userPreferences: null };
		default:
			return state;
	}
}
